import { useLinkOnSameOrg } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameOrg';

/** Link to the org-scoped documents folders list page. */
export function useDocumentFoldersLink() {
  return useLinkOnSameOrg('/data-setup/documents');
}

/** Link to the page that lists the files inside one organization-scoped folder. */
export function useDocumentFolderLink(folderId: string) {
  return useLinkOnSameOrg(`/data-setup/documents/${folderId}`);
}
